var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.7939 4.20625C21.9752 2.3875 19.0252 2.3875 17.2064 4.20625L5.20645 16.2062C2.28145 19.1312 2.28145 23.8688 5.20645 26.7938C8.13145 29.7188 12.8689 29.7188 15.7939 26.7938L25.294 17.2938C25.6814 16.9062 26.3189 16.9062 26.7064 17.2938C27.0939 17.6813 27.0939 18.3187 26.7064 18.7062L17.2064 28.2062C13.5002 31.9125 7.49395 31.9125 3.79395 28.2062C0.0939456 24.5 0.0876957 18.5 3.79395 14.7937L15.7939 2.79375C18.3939 0.19375 22.6064 0.19375 25.2064 2.79375C27.8064 5.39375 27.8064 9.60625 25.2064 12.2063L13.7189 23.6938C11.9564 25.4563 9.05645 25.2938 7.49395 23.35C6.1627 21.6875 6.29395 19.2875 7.8002 17.7812L17.2939 8.29375C17.6814 7.90625 18.3189 7.90625 18.7064 8.29375C19.0939 8.68125 19.0939 9.31875 18.7064 9.70625L9.21895 19.1938C8.43145 19.9813 8.3627 21.2313 9.05645 22.1C9.86895 23.1125 11.3814 23.2 12.3002 22.2812L23.7939 10.7937C25.6127 8.975 25.6127 6.025 23.7939 4.20625Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/Step_3.b6a1aa5456194a2229df7d6676e8a76f.svg";
export { ForwardRef as ReactComponent };